import "./why-carthy-video.css";
import { manageLoopingVideo } from "./video-playback-manager";

const VIDEO_SRC = "/brain-v2.mp4";

function installWhyCarthyVideo() {
  const section = document.querySelector("#why");
  if (!section) return false;
  if (section.querySelector(".why-carthy-video-stage")) return true;

  const inner = section.querySelector(":scope > .mx-auto");
  const copy = inner?.firstElementChild;
  const cards = copy?.nextElementSibling;
  if (!inner || !copy || !cards) return false;

  section.classList.add("why-carthy-video-section");
  inner.classList.add("why-carthy-video-layout");
  copy.classList.add("why-carthy-video-copy");
  cards.classList.add("why-carthy-video-cards");

  const stage = document.createElement("div");
  stage.className = "why-carthy-video-stage";
  stage.innerHTML = `
    <video
      class="why-carthy-video-element"
      src="${VIDEO_SRC}"
      muted
      loop
      playsinline
      preload="metadata"
      aria-label="Animation CARTHY autour de l'informatique quantique et de la infrastructure"
    ></video>
    <div class="why-carthy-video-vignette" aria-hidden="true"></div>
  `;

  inner.insertBefore(stage, cards);

  const video = stage.querySelector("video");
  if (video) manageLoopingVideo(video, stage);

  return true;
}

function boot() {
  if (installWhyCarthyVideo()) return;

  const observer = new MutationObserver(() => {
    if (installWhyCarthyVideo()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
